import api from './api';
import { downloadFromApi } from './download';

/**
 * Appels de l'écran « Exports » (lot 049): jeux de données en Excel, export
 * comptable et archive complète « Toutes mes données ».
 *
 * Aucun libellé d'écran ici; les noms de fichier viennent du serveur.
 */
const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const exportsAPI = {
  async jeux() {
    const reponse = await api.get('/export/datasets');
    return reponse.data?.data || { datasets: [], money: false };
  },

  telechargerJeu(nom) {
    return downloadFromApi(`/export/dataset/${nom}`, {}, `e-carbu-${nom}.xlsx`, XLSX);
  },

  telechargerEcritures({ du, au } = {}) {
    const params = {};
    if (du) params.date_from = du;
    if (au) params.date_to = au;
    return downloadFromApi('/export/accounting', params, 'e-carbu-ecritures-comptables.xlsx', XLSX);
  },

  async comptes() {
    const reponse = await api.get('/export/accounting/accounts');
    return reponse.data?.data?.accounts || [];
  },

  async enregistrerComptes(codes) {
    const reponse = await api.put('/export/accounting/accounts', { codes });
    return reponse.data?.data?.accounts || [];
  },

  async derniereArchive() {
    const reponse = await api.get('/export/all');
    return reponse.data?.data || null;
  },

  async lancerArchive() {
    const reponse = await api.post('/export/all');
    return reponse.data?.data || null;
  },

  telechargerArchive(id) {
    return downloadFromApi(`/export/all/${id}/download`, {}, 'e-carbu-donnees.zip', 'application/zip');
  },
};

/** Phrase française d'une erreur d'export (le serveur répond parfois par un fichier). */
export const messageErreurExport = async (error, repli) => {
  const donnees = error?.response?.data;
  if (donnees && typeof donnees.text === 'function') {
    try {
      const corps = JSON.parse(await donnees.text());
      return corps?.message || corps?.detail || repli;
    } catch {
      return repli;
    }
  }
  return donnees?.message || donnees?.detail || repli;
};

export default exportsAPI;
